const Style = {
    wrapper: 'flex flex-col h-[100px]',
    container: 'flex w-fit px-4 pb-2 h-full',
    title: 'flex text-md font-semibold py-2 px-6',
    icon: 'mr-2',
    media: 'w-fit p-2 relative hover:opacity-80',
    img: 'w-full h-full object-cover rounded-2xl shadow-md cursor-pointer',
};
export default Style;